export const seasons = ['Spring', 'Summer', 'Fall', 'Winter'];

export const threePlayerReq = [10, 20, 30, 50];

export const fourPlayerReq = [12, 25, 38, 60];

export function getColorfromChar(c: string) {
	switch (c) {
		case 'r':
			return 'red';
		case 'b':
			return 'blue';
		case 'g':
			return 'green';
		case 'y':
			// logg('hurr');
			return 'yellow';
		case 'c':
			return 'black';
		default:
			return 'test';
	}
}

export function getCharFromColor(c: string) {
	switch (c) {
		case 'red':
			return 'r';
		case 'blue':
			return 'b';
		case 'green':
			return 'g';
		case 'yellow':
			// logg('hurr');
			return 'y';
		case 'black':
			return 'c';
		case 'carbon':
			return 'c';
		default:
			return 'test';
	}
}
